<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
          <li class="breadcrumb-item" disabled><a routerLink="/corporate/subscription-license-route-list">License Routes</a></li>
          <li class="breadcrumb-item active" aria-current="page">Edit License Route</li>
      </ol>
  </nav>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-8">
      <form class="form-horizontal" [formGroup]="updateRouteForm">
        <div class="card">
          <div class="card-body">
            <div class="form-group" *ngIf="customer_id===0">
              <label>Company Name <span class="required">*</span></label>
              <select formControlName="selectedCompany" class="form-control formstyle"
                [ngClass]="{ 'is-invalid': submitted && f.selectedCompany.errors }">
                <option value="">Select Company Name</option>
                <ng-container *ngFor="let Obj of getCompanyobj">
                  <option *ngIf="Obj.dbstatus == true" value={{Obj.customer_id}}>
                    {{Obj.customer_company_name}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="submitted && f.selectedCompany.errors" class="invalid-feedback">
                <div *ngIf="f.selectedCompany.errors.required">Company Name is required</div>
              </div>
            </div>

            <input *ngIf="customer_id!=0" type="hidden" formControlName="selectedCompany">

            <div class="form-group">
              <label>License <span class="required">*</span></label>
              <select formControlName="license_id" class="form-control formstyle"
                [ngClass]="{ 'is-invalid': submitted && f.license_id.errors }">
                <option value="">Select License</option>
                <option *ngFor="let lic of licenseObj" [value]="lic.license_id">
                  {{lic.license_code}} - {{lic.license_name}}
                </option>
              </select>
              <div *ngIf="submitted && f.license_id.errors" class="invalid-feedback">
                <div *ngIf="f.license_id.errors.required">License is required</div>
              </div>
            </div>

            <div class="form-group">
              <label>Route <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="full_route"
                placeholder="/directseller/example"
                [ngClass]="{ 'is-invalid': submitted && f.full_route.errors }" maxlength="500">
              <div *ngIf="submitted && f.full_route.errors" class="invalid-feedback">
                <div *ngIf="f.full_route.errors.required">Route is required</div>
                <div *ngIf="f.full_route.errors.maxlength">You reached to maxlength</div>
              </div>
            </div>

            <div class="form-group">
              <label>Component</label>
              <input type="text" class="form-control" formControlName="component_name" maxlength="200">
            </div>

            <div class="form-group">
              <label>Action <span class="required">*</span></label>
              <select formControlName="action" class="form-control formstyle"
                [ngClass]="{ 'is-invalid': submitted && f.action.errors }">
                <option *ngFor="let act of actionOptions" [value]="act">{{act}}</option>
              </select>
              <div *ngIf="submitted && f.action.errors" class="invalid-feedback">
                <div *ngIf="f.action.errors.required">Action is required</div>
              </div>
            </div>

            <div class="form-group">
              <label>Also In Licenses</label>
              <input type="text" class="form-control" formControlName="also_in_licenses"
                placeholder="QTL,MTE" maxlength="200">
              <small class="form-text text-muted">Optional extra license codes, comma-separated.</small>
            </div>

            <div class="form-group">
              <label>Component File</label>
              <input type="text" class="form-control" formControlName="component_file" maxlength="500">
            </div>

            <div class="form-group">
              <label>Source File</label>
              <input type="text" class="form-control" formControlName="source_file" maxlength="500">
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button class="btn btn-round btn-margo-action" type="button" (click)="updateRoute()">Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
